import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'orderdate', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'baris','jiklan', 'jiklanid', 'posisirubrik','billing', 'isinvoiced', 'completed', 'komplitjadwal','createby', 'jenisbayar'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koraniklanorder${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    invoicing(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'orderdate', 'orderno', 'customer_id', 'tgl1', 'tgl2', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'pemasang','jiklan', 'jiklanid', 'billing', 'isinvoiced', 'completed', 'komplitjadwal','createby', 'jenisbayar'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koraniklanorder/invoicing${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    invoicingsuccess(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post('/koraniklanorder/invoicingsuccess', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    paymentForms() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get("/koraniklanorder/paymentForm");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    print(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // console.log('obj : ', obj);
                const { data } = await axios.get(`/koraniklanorder/print/${obj.orderid}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post('/koraniklanorder', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/koraniklanorder/${obj.orderid}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // console.log('obj : ', obj);
                const { data } = await axios.get(`/koraniklanorder/detail/${obj.orderid}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }, 
    kelompokib() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/koraniklanorder/kelompokib");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    paymentform() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/koraniklanorder/paymentform");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
    return new Promise((resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'orderdate', 'orderno', 'customer_id', 'platform', 'tgl1', 'tgl2', 'pemasang', 'Advertiser', 'mediaorder', 'juduliklan', 'brand', 'salesae_id', 'salesae_name', 'baris', 'jiklanid', 'jiklan','posisirubrik','billing', 'isinvoiced', 'completed', 'komplitjadwal','createby', 'jenisbayar'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            axios({
                url: `/koraniklanorder/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'order_iklan_list.xlsx');
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });

        } catch (error) {
            errorHandler(error, reject)
        }
    });
}    
};